import AuthService from '../../services/AuthService';
import { canProductInquiry } from './canProductInquiry';

export const canProductBuy = (product: GQL.IProduct) => {
  let { customerGroupId } = AuthService.GetInstance();

  // Can't buy product for customer group if user is not in this group
  if (product.visibleForCustomerGroup) {
    // User does not have any customer group
    if (!customerGroupId) {
      return false;
    }

    if (!Array.isArray(customerGroupId)) {
      customerGroupId = [customerGroupId];
    }

    // User has some customer groups, but none of them is one required by product
    if (
      !product.visibleForCustomerGroup.some(productCustomerGroupId =>
        customerGroupId!.includes(productCustomerGroupId),
      )
    ) {
      return false;
    }
  }

  if (!canProductInquiry(product) && product.display) {
    return product.display === true && product.status === 1;
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/helpers/products/canProductBuy.ts